module.exports = __webpack_public_path__ + "static/media/dorm-secundario.477817a7.jpg";